module.exports = __webpack_public_path__ + "img/banner-3.096990f7.jpg";